<template>
  <div class="header">
    <i class="el-icon-s-fold hiden_btn" @click="hidenMenu"></i>
    <div class="right">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link cursor_pointer" style="color:#409EFF ">
          <i class="el-icon-user-solid"></i>
          <a>{{userInfo.nickName}}</a>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="loginOut()">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
  import Util from "../Util.js";
  import loadSelect from "../components/loadSelect"
  export default {
    name: "Header",
    components: {
      loadSelect
    },
    data() {
      return {
        dialog: false,
        dialogLogin: false,
        dialogAdd: false,
        dialogDeviceId: false,
        dialogUpdate: false,
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        loginForm: {
          account: "",
          password: ""
        },
        addForm: {
          platId: "",
          nickName: "",
          account: "",
          password: ""
        },
        updateForm: {
          oldPwd: '',
          newPwd: '',
          accPwd: ''
        },
        userChangeForm:{
          changeFee: 0,
          orderNum: 0,
          crash: 0,
          onlienMoney: 0
        },
        fieldList: [],
        userMessage: null,
        platDeviceList: [],
        platDeviceId: "",
        userInfoData: {
          bdUserId: ""
        }, //暂存userInfo的数据
        formFieldData: { //场地分页
          page: 1,
          size: 10
        },
        formDeviceData: { //设备分页
          page: 1,
          size: 10
        },
      };
    },
    computed: {
      showMenu() {
        return this.$store.state.showMenu;
      },
      userInfo() {
        return this.$store.state.userInfo;
      },
    },
    watch: {
      "loginForm.account"(val, oldVal) {
        this.loginForm.account = val
        this.$forceUpdate()
      },
      "loginForm.password"(val, oldVal) {
        this.loginForm.password = val
        this.$forceUpdate()
      },
      "addForm.platId"(val, oldVal) {
        this.addForm.platId = val
        this.$forceUpdate()
      },
      "addForm.nickName"(val, oldVal) {
        this.addForm.nickName = val
        this.$forceUpdate()
      },
      "addForm.account"(val, oldVal) {
        this.addForm.account = val
        this.$forceUpdate()
      },
      "addForm.password"(val, oldVal) {
        this.addForm.password = val
        this.$forceUpdate()
      },
    },
    mounted() {},
    methods: {
      changePlatDeviceId(val) {
        this.platDeviceId = val
      },
      changePlatField(val) {
        this.addForm.platId = val
      },
      querySearch(queryString, cb) {
        var restaurants = JSON.parse(localStorage.getItem("accountList")) || [];
        for (let i in restaurants) {
          restaurants[i] = {
            value: restaurants[i]
          }
        }
        var results = queryString ?
          restaurants.filter(this.createFilter(queryString)) :
          restaurants;
        cb(results);
      },
      createFilter(queryString) {
        return restaurant => {
          return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0
          );
        };
      },
      hidenMenu() {
        this.$store.commit("setParam", {
          showMenu: !this.showMenu
        })
      },
      //  点击新增操作员-弹框
      add() {
        this.dialogAdd = true
        if (this.$refs['addForm']) {
          this.$refs['addForm'].resetFields();
        }
        this.searchFieldVal = ""
      },
      //   新增操作员-接口
      addSubmit() {
        this.$refs["addForm"].validate((valid) => {
          if (valid) {
            this.$http.post(`${Util.operateURL}platUser/addOpUser`, this.addForm).then(
              res => {
                if (res.data.code === 200) {
                  Util.message("suc", res.data.desc)
                  this.dialogAdd = false
                } else {
                  Util.message("err", res.data.desc)
                }
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        });
      },
      //   退出登录
      loginOut() {
        this.$http.post(`${Util.operateURL}deviceManage/logout`).then(
          res => {
            if (res.data.code === 200) {
              Util.message("suc", res.data.desc)
              Util.delCookie("token");
              this.$router.push({
                name: "Login"
              });
            } else {
              Util.message("err", res.data.desc)
            }
          },
          err => {
            console.log(err);
          }
        );
      },
      //   交接班-弹框
      dialogFn() {
        this.dialog = true
        this.platDeviceList = []
        this.platDeviceId = ""
        if (this.$refs['loginForm']) {
          this.$refs['loginForm'].resetFields();
        }
        this.getRevenue()
      },
      // 交接时查询收费
      getRevenue() {
        this.$http.post(`${Util.searchURL}parking/checkChangeShiftsIncome`).then(
          res => {
            if (res.data.code === 200) {
              this.userMessage = res.data.data
            }
          },
          err => {
            console.log(err);
          }
        );
      },
      changeMoney() {
        this.dialogLogin = true
        this.dialog = false
        this.platDeviceId = ''
        this.chengFee(this.userMessage)
      },
      //   交接班的手续费
      chengFee(val) {
        this.userChangeForm = {
          changeFee: val && val.total_income || 0,
          orderNum: val && val.orderNum || 0,
          crash: val && val.crash || 0,
          onlienMoney: val && val.online_money || 0
        }
        this.$http.post(`${Util.operateURL}platUser/userChange`, this.userChangeForm).then(
          res => {
            if (res.data.code === 200) {
              console.log(res)
            }
          },
          err => {

            console.log(err);
          }
        )
      },
      //   重置密码
      reset() {
        this.$http.post(`${Util.operateURL}platUser/resetPwd`, {
          bdUserId: this.userInfo.bdUserId
        }).then(
          res => {
            if (res.data.code === 200) {
              Util.message("suc", res.data.desc)
            }
          },
          err => {
            console.log(err);
          }
        );
      },
      //   更换密码-弹窗
      update() {
        this.dialogUpdate = true
        if (this.$refs['updateForm']) {
          this.$refs['updateForm'].resetFields();
        }
      },
      //   新增操作员-接口
      updateSubmit() {
        this.$refs["updateForm"].validate((valid) => {
          if (valid) {
            this.$http.post(`${Util.operateURL}platUser/updatePwd`, this.updateForm).then(
              res => {
                if (res.data.code === 200) {
                  Util.message("suc", res.data.desc)
                  this.dialogUpdate = false
                } else {
                  Util.message("err", res.data.desc)
                }
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        });
      },
      //   退出登录
      outSubmit() {
        this.$http.post(`${Util.operateURL}deviceManage/logout`).then(
          res => {
            if (res.data.code === 200) {
              this.goPage()
            }
          },
          err => {
            console.log(err);
          }
        );
      },
      selectPlatDeviceId() {
        if (!this.platDeviceId) {
          Util.message("err", "请选择设备")
          return
        }
        this.$store.commit("setParam", {
          platDeviceId: this.platDeviceId
        })
        this.login()
      },
      //   登录-接口
      login() {
        this.$refs["loginForm"].validate((valid) => {
          if (valid) {
            if (this.platDeviceId) {
              this.loginForm.platDeviceId = this.platDeviceId
            }
            this.$http.post(`${Util.operateURL}/deviceManage/Login`, this.loginForm).then(
              res => {
                if (res.data.code === 200) {
                  this.userInfoData = res.data.data
                  if (this.userInfoData.userType == 1 && !this.platDeviceId) {
                    this.dialogLogin = false
                    this.dialogDeviceId = true
                    this.formDeviceData = {
                      page: 1,
                      size: 10
                    }
                  } else if (this.userInfoData.userType == 1 && this.platDeviceId) {
                    this.goPage()
                  } else {
                    this.outSubmit()
                  }

                } else {
                  Util.message("err", res.data.desc)
                }
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        });
      },
      goPage() {
        this.$store.commit("setParam", {
          userInfo: this.userInfoData
        })
        Util.setCookie("token", this.userInfoData.token, 24 * 365);
        let accountList = JSON.parse(localStorage.getItem("accountList")) || []
        if (accountList.indexOf(this.loginForm.account) == -1) {
          accountList = [...accountList, this.loginForm.account]
        }
        localStorage.setItem("accountList", JSON.stringify(accountList))
        Util.message("suc", "登录成功！")
        this.$router.go(0)
      },
      getNewTime() {
        return Util.getNewTime()
      }
    }
  };

</script>

<style lang="less" scoped>
  .inline_block {
    display: inline-block;
  }

  .header {
    // position: fixed;
    line-height: 60px;
    display: flex;

    .hiden_btn {
      margin-right: 15px;
      font-size: 24px;
      padding-top: 18px;
    }
  }

  .right {
    width: calc(100vw);

    .name {
      margin-right: 20px;
      font-size: 24px;
    }

    .add_btn {
      padding: 10px 16px;
      margin-right: 35px;
    }
  }

  .message {
    padding-left: 114px;
    font-size: 17px;

    span {
      color: red;
    }
  }

  .dialog-footer {
    button {
      width: 160px;
    }
  }

  .btn {
    width: 100%;
    margin-top: 20px;
  }

  .demo-addForm,
  .message,
  .demo-loginForm {
    padding: 0px 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue